export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14528.c3624ce9.jpg";